import { render, staticRenderFns } from "./FavoritesList.vue?vue&type=template&id=7980328e&scoped=true&lang=pug"
import script from "./FavoritesList.vue?vue&type=script&lang=js"
export * from "./FavoritesList.vue?vue&type=script&lang=js"
import style0 from "./FavoritesList.vue?vue&type=style&index=0&id=7980328e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980328e",
  null
  
)

export default component.exports